import { render, staticRenderFns } from "./TemplateAddressComponent.vue?vue&type=template&id=09fddb33&scoped=true&"
import script from "./TemplateAddressComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateAddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateAddressComponent.vue?vue&type=style&index=0&id=09fddb33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fddb33",
  null
  
)

export default component.exports